import { jsx } from 'panel';
import { SvgIconEl } from '../svg-icon';
export function template() {
  const icon = this.attr("icon");
  return jsx("span", null, jsx("div", {
    sel: '.mp-text-highlight',
    class: {
      [this.attr("theme")]: true,
      ["size-".concat(this.attr("size"))]: true,
      ["length-".concat(this.attr("length"))]: true
    }
  }, icon && jsx(SvgIconEl, {
    attrs: {
      icon
    }
  }), jsx("div", {
    sel: '.text'
  }, this.attr("text"))), jsx("slot", null));
}